import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b64a2e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类型：", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("用户")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("商家")
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送成功")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("发送失败")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "司机消息记录",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          align: "middle",
          gutter: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.type,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.type) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('type', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.name) = $event)),
                    "enter-button": "",
                    onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('keyword', $event, $event))),
                    placeholder: "搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'message' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", null, "标题：" + _toDisplayString(record.title), 1),
              _createElementVNode("div", null, "副标题：" + _toDisplayString(record.sub_title), 1),
              _createElementVNode("div", null, _toDisplayString(text), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'user' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(text?.courier?.name), 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(text?.courier?.phone), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'type' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text.name), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'send_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text ? _ctx.dateFormat(text * 1000) : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'read_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(text ? _ctx.dateFormat(text * 1000) : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              (text.status)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "#87d068"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "#f50"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}